export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}
// 根据某个属性值从MenuList查找拥有该属性值的menuItem
export function getMenuItemInMenuListByProperty(menuList, key, value) {
  let stack = [];
  stack = stack.concat(menuList);
  let res;
  while (stack.length) {
    let cur = stack.shift();
    if (cur.children && cur.children.length > 0) {
      stack = cur.children.concat(stack);
    }
    if (value === cur[key]) {
      res = cur;
    }
  }
  return res;
}

/**
 * @description 将时间戳转换为年-月-日-时-分-秒格式
 * @param {String} timestamp
 * @returns {String} 年-月-日-时-分-秒
 */
export function timestampToTime(timestamp) {
  var date = new Date(timestamp);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

  let strDate = Y + M + D + h + m + s;
  return strDate;
}

/**
 * @description 将数组根据某个字段进行排序
 * @param 字段名
 * @returns 返回排序好的数组
 */
export function arraySort(field) {
  return (a, b) => {
    const value1 = a[field]
    const value2 = b[field]
    return value1 - value2
  }
}

export function groupBy(list, name) {
  return list.reduce((obj, item) => {
    if (!obj[item[name]]) {
      obj[item[name]] = []
      obj[item[name]].push(item)
    } else {
      obj[item[name]].push(item)
    }
    return obj
  }, {})
}

/**
 * 是否在微信客户端
 */
export function isInWechat() {
  var ua = window.navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger')
}

//json 转换 object
export function formatJSON(str) {
  if (typeof str === 'object')
    return str;

  if (typeof str === 'string') {
    try {
      return JSON.parse(str);
    } catch (ex) {
      return null;
    }
  }
}

export function isVideoFile(fileName) {
  const videoExtensions = [".mp4", ".avi", ".mov", ".mkv", ".wmv", ".flv"];
  const fileExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
  return videoExtensions.includes(fileExtension);
}

export function isURLValid(url) {
  // 定义一个正则表达式模式，用于匹配有效的 URL 格式
  const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

  // 使用正则表达式测试给定的 URL
  return urlPattern.test(url);
}

export function getUrlParam(key) {
  let url = window.location.href;
  if (url.indexOf('#rd') > -1) {
    url = url.replace('#rd', '');
  }
  const sValue = url.match(new RegExp('[?&]' + key + '=([^&]*)(&?)', 'i'));

  const res = sValue ? sValue[1] : sValue;
  return res && decodeURI(res);
}

/**
 * 递归查找指定条件的节点
 * @param {Array} data - 数据数组
 * @param {Object} conditions - 查找条件
 * @returns {Object|null} - 返回找到的节点或null
 */
const findNode = (data, conditions) => {
  // 深度优先搜索
  const dfs = (nodes) => {
      if (!nodes || !nodes.length) return null;
      
      for (const node of nodes) {
          // 检查当前节点是否符合所有条件
          if (Object.entries(conditions).every(([key, value]) => node[key] === value)) {
              return node;
          }
          
          // 递归检查子节点
          if (node.children) {
              const found = dfs(node.children);
              if (found) return found;
          }
      }
      
      return null;
  };
  
  return dfs(data);
}

/**
 * 迭代查找指定条件的节点
 * @param {Array} data - 数据数组
 * @param {Object} conditions - 查找条件
 * @returns {Object|null} - 返回找到的节点或null
 */
const findNodeIterative = (data, conditions) => {
  if (!data || !data.length) return null;
  
  // 使用队列进行广度优先搜索
  const queue = [...data];
  
  while (queue.length > 0) {
      const node = queue.shift();
      
      // 检查当前节点是否符合所有条件
      if (Object.entries(conditions).every(([key, value]) => node[key] === value)) {
          return node;
      }
      
      // 将子节点加入队列
      if (node.children && node.children.length) {
          queue.push(...node.children);
      }
  }
  
  return null;
};